export default function useDisplayImageFullScreen(storeDispatch: Function) {
  const setPreviewAttachmentId = (id: string, resourceId: string) => {
    storeDispatch('setPreviewAttachmentId', {
      attachmentId: id,
      resourceId: resourceId,
    });
  };

  const displayImageFullScreen = (images: any, id: string, resourceId: string) => {
    const attachment = images.find((a: any) => a.id === id);
    storeDispatch('setPreviewAttachments', images);
    storeDispatch('setAttachmentPreviewFromInput', true);
    if (!attachment) {
      if (id.startsWith('unsplash')) {
        setPreviewAttachmentId(id, resourceId);
        return;
      }
      storeDispatch('getFile', id).then((file: any) => {
        if (!file.id) return;
        storeDispatch('setPreviewAttachments', [...images, file]);
        setPreviewAttachmentId(file.id, resourceId);
      });
      return;
    }
    setPreviewAttachmentId(attachment.id, resourceId);
  };

  return { displayImageFullScreen };
}
